<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">{{'Movimiento' | translate}} desde Documento</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content style="margin-bottom: 0%;">

    <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label class="text-style" *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isValidating">

      <!--SELECCION PAGO O DEUDA-->
      <mat-expansion-panel [expanded]="true" *ngIf="canAddPago && canAddDeuda">

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin-top: 10px;">
          <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="text-align: center; margin-bottom: 8px;">
            <mat-label style="font-weight: bold; font-size: 16px;">¿A qué operación corresponden los documentos a leer?</mat-label>
          </div>
          <br />
          <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="text-align: center;">
            <button mat-raised-button (click)="onPagoClick()"  [disabled]="isSaving"
              class="zb-button" [ngStyle]="{ 'background-color': operacion === 1 ? '#ffd000' : '#fff'}">{{'MovimientoPago' | translate}}</button>
            <button mat-raised-button (click)="onDeudaClick()"  [disabled]="isSaving" class="zb-button"
              [ngStyle]="{ 'background-color': operacion < 0 ? '#ffd000' : '#fff'}">{{'MovimientoDeuda' | translate}}</button>
          </div>
        </div>

      </mat-expansion-panel>

      <ng-container *ngIf="operacion != 0">

        <br/>

        <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

          <mat-expansion-panel-header>
            <mat-panel-title class="card-subtitulo">
              <mat-icon style="margin-top: -3px;">playlist_add_check</mat-icon> Listado de Movimientos Analizados
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label style="font-weight: bold;">A continuación, adjunta todos los archivos que queres que sean analizados y convertidos en movimientos:</mat-label>
          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 5px;">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
              <button mat-icon-button matSuffix (click)="adjuntoInput.click()" [disabled]="isFileAttaching">
                <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjuntos
              </button>
              <input hidden (change)="onNewFileAttach($event)" #adjuntoInput type="file" multiple>
              <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...</mat-label>
            </div>

          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" *ngFor="let file of item.Adjuntos" style="margin: 5px;">

            <mat-expansion-panel [expanded]="true" hideToggle="false" style="width: 100%;">

              <mat-expansion-panel-header>
                <mat-panel-title class="card-subtitulo">
                  <div fxFlex=5 fxFlex.xs=5 class="flex-item" style="margin-right: 8px;">
                    <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
                      <i class="fa fa-trash fa-1x"></i>
                    </button>
                  </div>
                  <div fxFlex=95 fxFlex.xs=95 class="flex-item" style="margin-top: 10px;">
                    <b style="margin-right: 3px;"><u>Archivo</u>:</b> <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                  </div>
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <ng-container *ngIf="operacion != 0 && hasAnalyzed">

                <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!file.Success">
                  <mat-label style="font-weight: bold;">Ocurrió un error analizando: {{file.MensajeError}}</mat-label>
                </div>

                <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="file.Success">

                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorFechaMovimiento(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorFechaMovimiento(file)?.length > 0 ? '#E53935' : 'auto')}">Fecha de Movimiento*</mat-label>
                      <input matInput [matDatepicker]="fechaMovimientoPicker" [(ngModel)]="file.FechaMovimiento"  (click)="fechaMovimientoPicker.open()">
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoPicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaMovimientoPicker></mat-datepicker>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorFechaMovimiento(file)?.length > 0">
                      {{ getErrorFechaMovimiento(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorTipoMovimientoId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label *ngIf="!isTipoMovimientoSearching">Tipo de Movimiento*</mat-label>
                      <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
                      <mat-select [(ngModel)]="file.TipoMovimientoId">
                        <mat-option *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorTipoMovimientoId(file)?.length > 0">
                      {{ getErrorTipoMovimientoId(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngIf="canChangeState">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorEstadoId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label *ngIf="!isEstadoSearching" [ngStyle]="{'color': (getErrorEstadoId(file)?.length > 0 ? '#E53935' : 'auto')}">Estado*</mat-label>
                      <mat-label *ngIf="isEstadoSearching">Cargando...</mat-label>
                      <mat-select [(ngModel)]="file.EstadoId">
                        <mat-option *ngFor="let s of estadoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorEstadoId(file)?.length > 0">
                      {{ getErrorEstadoId(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngIf="operacion < 0 || (operacion > 0 && esEstadoPendiente(file))">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorFechaVencimiento(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorFechaVencimiento(file)?.length > 0 ? '#E53935' : 'auto')}">Fecha Vencimiento*</mat-label>
                      <input matInput [matDatepicker]="fechaVencimientoPicker" [(ngModel)]="file.FechaVencimiento"  (click)="fechaVencimientoPicker.open()">
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoPicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaVencimientoPicker></mat-datepicker>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorFechaVencimiento(file)?.length > 0">
                      {{ getErrorFechaVencimiento(file) }}
                    </mat-label>
                  </div>

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorDetalle(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorDetalle(file)?.length > 0 ? '#E53935' : 'auto')}">Detalle*</mat-label>
                      <input matInput [(ngModel)]="file.Detalle" maxlength="100">
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorDetalle(file)?.length > 0">
                      {{ getErrorDetalle(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorNroComprobante(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorNroComprobante(file)?.length > 0 ? '#E53935' : 'auto')}">Nro. Comprobante</mat-label>
                      <input matInput [(ngModel)]="file.NroComprobante" maxlength="100">
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorNroComprobante(file)?.length > 0">
                      {{ getErrorNroComprobante(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngIf="operacion > 0">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorMedioPagoId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label *ngIf="!isMedioPagoSearching">Medio de Pago*</mat-label>
                      <mat-label *ngIf="isMedioPagoSearching">Cargando...</mat-label>
                      <mat-select [(ngModel)]="file.MedioPagoId">
                        <mat-option *ngFor="let s of medioPagoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorMedioPagoId(file)?.length > 0">
                      {{ getErrorMedioPagoId(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngIf="!(operacion > 0)">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorAlicuotaIvaId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label *ngIf="!isAlicuotaIvaSearching">Alicuota IVA*</mat-label>
                      <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
                      <mat-select [(ngModel)]="file.AlicuotaIvaId" (selectionChange)="onAlicuotaIvaSelect(file)">
                        <mat-option *ngFor="let s of alicuotaIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorAlicuotaIvaId(file)?.length > 0">
                      {{ getErrorAlicuotaIvaId(file) }}
                    </mat-label>
                  </div>

                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorMonedaId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label *ngIf="!isMonedaSearching">Moneda*</mat-label>
                      <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                      <mat-select [(ngModel)]="file.Moneda" (selectionChange)="onMonedaSelect(file)">
                        <mat-option *ngFor="let s of monedaList" [value]="s">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorMonedaId(file)?.length > 0">
                      {{ getErrorMonedaId(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorMontoBase(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorMontoBase(file)?.length > 0 ? '#E53935' : 'auto')}">Importe Base*</mat-label>
                      <input matInput type="number" [(ngModel)]="file.MontoBase" (change)="calcularMontos(file)">
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorMontoBase(file)?.length > 0">
                      {{ getErrorMontoBase(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;">
                      <mat-label>Importe Impuestos*</mat-label>
                      <input matInput type="number" [(ngModel)]="file.MontoAlicuotaIva" (change)="calcularMontos(file)">
                    </mat-form-field>
                    <!-- <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorMontoAlicuotaIva(file)?.length > 0">
                      {{ getErrorMontoAlicuotaIva(file) }}
                    </mat-label> -->
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorMonto(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorMonto(file)?.length > 0 ? '#E53935' : 'auto')}">Importe Total*</mat-label>
                      <input matInput type="number" [(ngModel)]="file.Monto" (change)="calcularMontos(file)">
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorMonto(file)?.length > 0">
                      {{ getErrorMonto(file) }}
                    </mat-label>
                  </div>

                  <div fxFlex=40 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorCuentaImputadaId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label>{{operacion > 0 ? 'Cuenta Imputada del Pago' : 'Cuenta Imputada a la Deuda*'}}</mat-label>
                      <mat-select [(ngModel)]="file.CuentaImputadaId">
                        <mat-option *ngIf="operacion > 0">Ninguna</mat-option>
                        <mat-option *ngFor="let s of file.CuentaImputadas" [value]="s.Id">
                          {{s.Codigo != null && s.Codigo.length > 0 ? s.Codigo + ' - ' : (s.Titular != null && s.Titular.length > 0 ? s.Titular + ' - ' : '')}}
                          {{s.MonedaCodigo}} - {{s.BancoNombre}} - {{s.Alias != null && s.Alias.length > 0 && s.Alias != '.' ? s.Alias : s.ClaveBancaria}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorCuentaImputadaId(file)?.length > 0">
                      {{ getErrorCuentaImputadaId(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=10 fxFlex.xs=100 class="flex-item">
                    <button mat-raised-button (click)="openDialogCuentaImputadaSearch(file)" [disabled]="isProcessing()" color="primary" style="margin-top: 10px !important;">
                      <mat-icon>search</mat-icon>
                    </button>
                  </div>

                  <div fxFlex=40 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;">
                      <mat-label>{{operacion > 0 ? 'Cuenta Origen de Fondos' : 'Cuenta Destino de Fondos'}}</mat-label>
                      <mat-select [(ngModel)]="file.CuentaDetalleId">
                        <mat-option>Ninguna</mat-option>
                        <mat-option *ngFor="let s of file.CuentaDetalles" [value]="s.Id">
                          {{s.Codigo != null && s.Codigo.length > 0 ? s.Codigo + ' - ' : (s.Titular != null && s.Titular.length > 0 ? s.Titular + ' - ' : '')}}
                          {{s.MonedaCodigo}} - {{s.BancoNombre}} - {{s.Alias != null && s.Alias.length > 0 && s.Alias != '.' ? s.Alias : s.ClaveBancaria}}
                        </mat-option>
                      </mat-select>
                      <!-- <mat-error *ngIf="getErrorCuentaDetalleId(file)?.length > 0">
                        {{ getErrorCuentaDetalleId(file) }}
                      </mat-error> -->
                    </mat-form-field>
                  </div>
                  <div fxFlex=10 fxFlex.xs=100 class="flex-item">
                    <button mat-raised-button (click)="openDialogCuentaDetalleSearch(file)" [disabled]="isProcessing()" color="primary" style="margin-top: 10px !important;">
                      <mat-icon>search</mat-icon>
                    </button>
                  </div>

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                    <!-- <mat-expansion-panel [expanded]="true" hideToggle="true"> -->
                      <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorObservacion(file)?.length > 0 ? '-25px' : '0px')}">
                        <mat-label [ngStyle]="{'color': (getErrorObservacion(file)?.length > 0 ? '#E53935' : 'auto')}">Observación</mat-label>
                        <textarea matInput [(ngModel)]="file.Observacion" maxlength="300"></textarea>
                      </mat-form-field>
                      <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorObservacion(file)?.length > 0">
                        {{ getErrorObservacion(file) }}
                      </mat-label>
                    <!-- </mat-expansion-panel> -->
                  </div>

                  <!-- Configuracion de cuotas -->
                  <ng-container *ngIf="!(operacion > 0)">

                    <hr style="margin: 10px 0px; width: 100%;">

                    <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorCantidadCuotas(file)?.length > 0 ? '-25px' : '0px')}">
                        <mat-label [ngStyle]="{'color': (getErrorCantidadCuotas(file)?.length > 0 ? '#E53935' : 'auto')}">Cuotas*</mat-label>
                        <input matInput type="number" [(ngModel)]="file.CantidadCuotas" (change)="calcularMontos(file)">
                      </mat-form-field>
                      <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorCantidadCuotas(file)?.length > 0">
                        {{ getErrorCantidadCuotas(file) }}
                      </mat-label>
                    </div>

                    <ng-container *ngIf="(file.CantidadCuotas > 1)">

                      <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                        <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorFechaInicioCuota(file)?.length > 0 ? '-25px' : '0px')}">
                          <mat-label [ngStyle]="{'color': (getErrorFechaInicioCuota(file)?.length > 0 ? '#E53935' : 'auto')}">Fecha de Inicio de Cuota*</mat-label>
                          <input matInput [matDatepicker]="fechaInicioCuotaPicker" [(ngModel)]="file.FechaInicioCuota"  (click)="fechaInicioCuotaPicker.open()">
                          <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaInicioCuotaPicker">
                          </mat-datepicker-toggle>
                          <mat-datepicker #fechaInicioCuotaPicker></mat-datepicker>
                        </mat-form-field>
                        <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorFechaInicioCuota(file)?.length > 0">
                          {{ getErrorFechaInicioCuota(file) }}
                        </mat-label>
                      </div>
                      <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                        <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorDiasRepeticionCuotas(file)?.length > 0 ? '-25px' : '0px')}">
                          <mat-label [ngStyle]="{'color': (getErrorDiasRepeticionCuotas(file)?.length > 0 ? '#E53935' : 'auto')}">Periodicidad de Cuotas (en días)*</mat-label>
                          <input matInput type="number" [(ngModel)]="file.DiasRepeticionCuotas" maxlength="5">
                        </mat-form-field>
                        <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorDiasRepeticionCuotas(file)?.length > 0">
                          {{ getErrorDiasRepeticionCuotas(file) }}
                        </mat-label>
                      </div>
                      <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                        <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorPorcentajeAjusteCuota(file)?.length > 0 ? '-25px' : '0px')}">
                          <mat-label [ngStyle]="{'color': (getErrorPorcentajeAjusteCuota(file)?.length > 0 ? '#E53935' : 'auto')}">Porcentaje de Ajuste*</mat-label>
                          <input matInput type="number" [(ngModel)]="file.PorcentajeAjusteCuota" (change)="calcularMontos(file)">
                        </mat-form-field>
                        <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorPorcentajeAjusteCuota(file)?.length > 0">
                          {{ getErrorPorcentajeAjusteCuota(file) }}
                        </mat-label>
                      </div>
                      <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngIf="(file.PorcentajeAjusteCuota > 0)" style="margin-top: 10px;">
                        <mat-checkbox class="text-style" [(ngModel)]="file.AplicarAjusteIncremental" color="primary">
                          <mat-label style="white-space: normal !important;">Aplicar el porcentaje de ajuste de forma incremental en cada cuota</mat-label>
                        </mat-checkbox>
                      </div>

                      <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                        <mat-expansion-panel [expanded]="true" hideToggle="true">
                          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">
                            <mat-label class="text-style"><b>IMPORTE PRIMERA CUOTA</b>: {{file.MontoCuota | number:'1.2-2'}}</mat-label>
                          </div>
                        </mat-expansion-panel>
                      </div>

                    </ng-container>

                  </ng-container>

                </div>

              </ng-container>

            </mat-expansion-panel>

          </div>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="hasAnalyzed && item?.Adjuntos != null && item?.Adjuntos.length > 0">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;" [ngStyle]="{'background-color': (operacion > 0 ? 'rgb(128, 202, 128)' : 'indianred')}">
                <mat-label><b>MONTOS TOTALES:</b></mat-label>
                <br/>
                <ng-container>
                  <mat-label *ngFor="let item of totalesSeleccionados" style="margin: 10px 0px 0px 10px;">
                    <b>{{item.key}}:</b> <span style="margin-left: 5px;">{{item.value | number: '1.2-2'}}</span> <br/>
                  </mat-label>
                </ng-container>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions>
    <div class="flex-actions">
      <button mat-raised-button (click)="onAnalizar()" [disabled]="isProcessing()" color="primary" class="zb-button" *ngIf="operacion != 0 && !hasAnalyzed && (item?.Adjuntos != null && item?.Adjuntos.length > 0)">
        {{isAnalyzing ? 'Analizando...' : 'Analizar Documentos'}}
      </button>
      <button mat-raised-button (click)="onGuardar()" [disabled]="isProcessing()" color="primary" class="zb-button" *ngIf="hasAnalyzed && item?.Adjuntos != null && item?.Adjuntos.length > 0">
        {{isSaving ? 'Guardando...' : 'Guardar'}}
      </button>
      <button mat-raised-button (click)="onCancel()" color="warn">Cancelar</button>
      <button mat-raised-button (click)="onClean()" [disabled]="isProcessing()" *ngIf="operacion != 0 && item?.Adjuntos != null && item?.Adjuntos.length > 0">
        {{isResetting ? 'Limpiando...' : 'Reiniciar'}}
      </button>
    </div>
  </mat-card-actions>

</mat-card>
